export default "__VITE_ASSET__CWMaDEqd__"